import { Edit2 } from 'react-feather';
import styled from '@emotion/styled';
import { FormButtons } from '../../presentation/FormButtons';

export type TagDetailsSectionEditButtonsProps = {
  isEditing: boolean;
  isSaving?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
};

/**
 * Reusable circular edit / save / cancel icon buttons for section card headers.
 * Renders a single Edit button when not editing, or Cancel + Save when editing.
 */
export const TagDetailsSectionEditButtons = ({
  isEditing,
  isSaving = false,
  onEdit,
  onSave,
  onCancel,
}: TagDetailsSectionEditButtonsProps) =>
  isEditing ? (
    <>
      <FormButtons disabled={isSaving} onCancel={onCancel} onSubmit={onSave} size={28} />
    </>
  ) : (
    <RoundButton onClick={onEdit} title="Edit" type="button">
      <Edit2 size={14} />
    </RoundButton>
  );

TagDetailsSectionEditButtons.displayName = 'TagDetails.SectionEditButtons';

type RoundButtonProps = { variant?: 'save' | 'cancel' };

export const RoundButton = styled.button<RoundButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid var(--pri-02);
  color: var(--pri-02);
  background: var(--white);
  transition: all 0.2s ease;

  &:hover {
    color: white;
    background: var(--pri-02);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
